import Highcharts from 'highcharts/highstock';
import {formatDateValue, getDate} from '~/js/helpers/date-helpers';
import getJSON from '~/js/helpers/xhr';
import moment from 'moment/dist/moment';
// import StockChartTable from '~/js/modules/stock-chart-table';
// import DateInputs from '~/js/modules/date-inputs';

// Highcharts.seriesTypes.line.prototype.drawLegendSymbol = function (legend) {
//   let markerOptions = {
//     symbol: `circle`,
//     width: 10,
//     height: 10,
//     enabled: 1,
//     radius: 5,
//   };
//   let radius = markerOptions.radius;
//   let legendSymbol;
//   let symbolWidth = markerOptions.width;
//   let renderer = this.chart.renderer;
//   let legendItemGroup = this.legendGroup;
//   let verticalCenter = legend.baseline - Math.round(legend.fontMetrics.b * 0.3);
//
//   // Draw the marker
//   if (markerOptions && markerOptions.enabled !== false && symbolWidth) {
//     this.legendSymbol = legendSymbol = renderer.symbol(markerOptions.symbol, symbolWidth / 2 - radius, verticalCenter - radius, 2 * radius, 2 * radius, markerOptions).addClass(`highcharts-point`).add(legendItemGroup);
//     legendSymbol.isMarker = true;
//   }
// };

export default class StockChart {

  constructor({chart, options, callbacks}) {
    this._element = chart;
    this._options = options;
    this._originalOptions = Highcharts.merge(this._options);
    this._callbacks = callbacks;

    this._chart = this._element.querySelector(`.js-stock-chart`)
    if (this._chart) {
      this._resId = this._chart.getAttribute(`data-res-id`)
      this._showMode = this._chart.getAttribute(`data-show-mode`)
      this._type = this._chart.getAttribute(`data-type`) ? this._chart.getAttribute(`data-type`) : 'pai'
      this._action = this._chart.getAttribute(`data-action`)
      this._tab = this._chart.getAttribute(`data-tab`) ? this._chart.getAttribute(`data-tab`) : 'prices'
    }
    this._table = null;

    this._instance = null;
    this._dates = {
      start: {
        type: `start`,
        instance: null,
        element: this._element.querySelector(`#stockStartDate`),
        label: this._element.querySelector(`#stockStartDate`)
          ? this._element.querySelector(`#stockStartDate`).previousElementSibling
          : null,
        value: null,
        dateValue: null,
        options: null,
      },
      end: {
        type: `end`,
        instance: null,
        element: this._element.querySelector(`#stockEndDate`),
        label: this._element.querySelector(`#stockEndDate`)
          ? this._element.querySelector(`#stockEndDate`).previousElementSibling
          : null,
        value: null,
        dateValue: null,
        options: null,
      },
    };

    this._dateInputs = null;
    this._seriesCounter = this._options.seriesCounter;

    this._setResponsiveOptions = this._setResponsiveOptions.bind(this);
    this._afterSetExtremes = this._afterSetExtremes.bind(this);
    this._setOffsetMins = this._setOffsetMins.bind(this);

    this.init()
  }

  // _getDateOptions({position, minDate, maxDate}) {
  //   const self = this;
  //
  //   return {
  //     field: position.element,
  //     firstDay: 1,
  //     defaultDate: new Date(position.dateValue),
  //     setDefaultDate: true,
  //     minDate,
  //     maxDate,
  //     showDaysInNextAndPreviousMonths: true,
  //     i18n: {
  //       previousMonth : 'Предыдущий месяц',
  //       nextMonth     : 'Следующий месяц',
  //       months        : ['Январь','Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'],
  //       weekdays      : ['Воскресерье','Понедельник','Вторник','Среда','Четверг','Пятница','Суббота'],
  //       weekdaysShort : ['Вс','Пн','Вт','Ср','Чт','Пт','Сб']
  //     },
  //     toString(date) {
  //       return date.toLocaleDateString();
  //     },
  //     onOpen() {
  //       // Удаление обработчика touchend, чтобы свайп на мобилке работал без срабатывания даты
  //       if (window.removeEventListener) {
  //         this.el.removeEventListener(`touchend`, this._onMouseDown, true);
  //       } else {
  //         this.el.detachEvent(`on` + `touchend`, this._onMouseDown);
  //       }
  //     },
  //     onSelect() {
  //       const currentDate = new Date(formatDateValue(position.element.value, true));
  //
  //       if (position.type === `start`) {
  //         self._dates.end.instance.setMinDate(self._getDate(currentDate, `Date`, 5));
  //       } else if (position.type === `end`) {
  //         self._dates.start.instance.setMaxDate(self._getDate(currentDate, `Date`, -5));
  //       }
  //
  //       self._dateInputs.setDateValues(position, position.element.value);
  //
  //       const startTimestamp = Date.parse(self._dates.start.dateValue);
  //       const endTimestamp = Date.parse(self._dates.end.dateValue);
  //
  //       self._instance.xAxis[0].setExtremes(startTimestamp, endTimestamp);
  //     },
  //     onClose() {
  //       self._dates.start.instance.gotoDate(self._dates.start.instance.getDate());
  //       self._dates.end.instance.gotoDate(self._dates.end.instance.getDate());
  //     }
  //   };
  // }

  // _getDate(date, dateType, value) {
  //   const newDate = new Date(date);
  //   newDate[`set${dateType}`](newDate[`get${dateType}`]() + value);
  //   return newDate;
  // }

  // _setValues(startValue, endValue) {
  //   this._dates.start.value = startValue;
  //   this._dates.end.value = endValue;
  //
  //   this._dates.start.dateValue = formatDateValue(this._dates.start.value, true);
  //   this._dates.end.dateValue = formatDateValue(this._dates.end.value, true);
  // }

  // _initDateInputs() {
  //   this._setValues(
  //       new Date(this._instance.navigator.xAxis.min).toLocaleDateString(),
  //       new Date(this._instance.navigator.xAxis.max).toLocaleDateString()
  //   );
  //
  //   this._dates.start.options = this._getDateOptions({
  //     position: this._dates.start,
  //     minDate: new Date(this._instance.navigator.xAxis.dataMin),
  //     maxDate: getDate(this._dates.end.dateValue, `Date`, -5),
  //   });
  //   this._dates.end.options = this._getDateOptions({
  //     position: this._dates.end,
  //     minDate: getDate(this._dates.start.dateValue, `Date`, 5),
  //     maxDate: new Date(this._instance.navigator.xAxis.dataMax),
  //   });
  //
  //   this._dateInputs = new DateInputs(this._dates);
  // }

  _setResponsiveOptions() {
    const updatedOptions = window.innerWidth >= 1024
      ? Highcharts.merge(this._originalOptions, this._originalOptions.responsiveRules)
      : Highcharts.merge(this._originalOptions.responsiveRules, this._originalOptions);
    this._instance.update(updatedOptions);
  }

  _afterSetExtremes(evt) {
      // границы графика - эти крайние точки не отображаются на графике
      const max = evt.max;
      const min = evt.min;
      evt.target.series.forEach(function (series, index, array) {
        let type = '';
        // удаляем из массива значения, которые не попадают в диапазон max и min
        const points = series.points.filter(item => item.x >= min && item.x <= max);
        // начальное значение отображенное на графике
        const endDate = points[points.length - 1];
        // предпоследлнее значение отображенное на графике
        const endPrevDate = points[points.length - 2];
        // конечное значение отображенное на графике
        const beginDate = points[0];
        switch (series.name) {
          case "Стоимость пая":
            type = 'Pai'
            break;
          case "Стоимость СЧА":
            type = 'Cha'
            break;
          // case "Курс доллара":
          //   type = 'UsdRate'
          //   break;
        }
        if(type) {
          if (!index) {
            document.getElementById(`stock${type}Data1`).textContent = new Date(endPrevDate.x).toLocaleDateString();
            document.getElementById(`stock${type}Data2`).textContent = new Date(endDate.x).toLocaleDateString();
            document.getElementById(`stock${type}BeginDate`).textContent = new Date(beginDate.x).toLocaleDateString();
            document.getElementById(`stock${type}EndDate`).textContent = new Date(endDate.x).toLocaleDateString();
            if (evt.trigger == 'rangeSelectorButton') {
              let text = '';
              switch (evt.rangeSelectorButton.type) {
                case 'month':
                  text = 'За ' + evt.rangeSelectorButton.count + ' ' + plural(['месяц', 'месяца', 'месяцев'], evt.rangeSelectorButton.count);
                  document.getElementById(`stock${type}BeginDate`).textContent = new Date(beginDate.x).toLocaleDateString();
                  break;
                case 'year':
                  text = 'За ' + evt.rangeSelectorButton.count + ' ' + plural(['год', 'года', 'лет'], evt.rangeSelectorButton.count);
                  document.getElementById(`stock${type}BeginDate`).textContent = new Date(beginDate.x).toLocaleDateString();
                  break;
                case 'ytd':
                  text = 'С начала года'
                  document.getElementById(`stock${type}BeginDate`).textContent = new Date(beginDate.x).toLocaleDateString();
                  break;
                case 'all':
                  text = 'С начала стратегии'
                  document.getElementById(`stock${type}BeginDate`).textContent = new Date(beginDate.x).toLocaleDateString();
                  break;
              }
              document.getElementById(`stock${type}PeriodPrefix`).textContent = text;
            } else if (evt.trigger == 'navigator') {
              document.getElementById(`stock${type}PeriodPrefix`).textContent = 'За период';
            }
          }
          document.getElementById(`stock${type}1`).textContent = endPrevDate.y.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
          document.getElementById(`stock${type}2`).textContent = endDate.y.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
          const diff = ((endDate.y - endPrevDate.y) / endPrevDate.y) * 100;
          const diff_element = document.getElementById(`stock${type}Diff`);
          diff_element.querySelector('.value').textContent = diff.toFixed(2).toString().replace("-", "");
          diff_element.classList.remove("charts__table-cell--profit");
          diff_element.classList.remove("charts__table-cell--loss");
          if (diff < 0) {
            diff_element.classList.add("charts__table-cell--loss");
          } else {
            diff_element.classList.add("charts__table-cell--profit");
          }
        }
      })

      function plural(forms, n) {
        let idx;
        // @see http://docs.translatehouse.org/projects/localization-guide/en/latest/l10n/pluralforms.html
        if (n % 10 === 1 && n % 100 !== 11) {
          idx = 0; // many
        } else if (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)) {
          idx = 1; // few
        } else {
          idx = 2; // one
        }
        return forms[idx] || '';
      }
  }

  /**
   * Вычисление смещения offsetMin для кнопок с периодами, на случай, если для даты начала периода данные отсутствуют
   * функция работает только в случае, если временные значения на графике имеют одинаковое время
   * и отличаются только днями
   * для работы функции должна быть установлена и подключена библиотека moment.js
   * @param hist - массив с данными для графика
   * @private
   */
  _setOffsetMins(hist) {
    if (this._options.rangeSelector.buttons.length) {
      let millisecondsInDay = 24 * 3600 * 1000;
      this._options.rangeSelector.buttons.forEach(function (button) {
        // последняя дата на графике с корректировкой времени из предпоследней даты
        // корректировка времени нужна, т. к. на некоторых графиках дата может быть с текущим временем
        // и в таком случае алгоритм данной функции не будет работать
        let periodEndDate = new Date(hist[hist.length - 1][0]);
        // предпоследняя дата на графике - из нее берем время и подставляем в дату-времы последней точки
        let periodPrevEndDate = new Date(hist[hist.length - 2][0]);
        periodEndDate.setHours(periodPrevEndDate.getHours())
        periodEndDate.setMinutes(periodPrevEndDate.getMinutes())
        periodEndDate.setSeconds(periodPrevEndDate.getSeconds())
        // начальная дата выбранного периода в unix - может отсутствовать
        let periodStartDateMilliseconds;
        switch (button.type) {
          case 'month':
            periodStartDateMilliseconds = moment(periodEndDate).subtract(button.count, 'months').unix()*1000;
            break;
          case 'year':
            periodStartDateMilliseconds = moment(periodEndDate).subtract(button.count, 'years').unix()*1000;
            break;
          case 'ytd':
            periodEndDate.setFullYear(periodEndDate.getFullYear());
            periodEndDate.setMonth(0);
            periodStartDateMilliseconds = periodEndDate.setDate(1);
            break;
          case 'all':
            periodStartDateMilliseconds = hist[0][0];
            break;
        }
        // вычисляем смещение только если дата начала периода больше первой точки графика
        if(periodStartDateMilliseconds > hist[0][0]) {
          // смещение offsetMin для кнопки графика, которое и будем вычислять
          let offsetMin = 0;
          // значение в точке графика - сначала в начале периода, потом со смещением на один день назад
          let itemOffset;
          // временная переменная для хранения времени смещения назад по точкам графика для поиска ближайшей точки
          let periodStartDateMillisecondsTemp = periodStartDateMilliseconds;
          // поиск значения на графике
          // количество итераций - неоходимо для корректировки ytd
          let j = 0;
          while (itemOffset === undefined && j < 100) {
            itemOffset = hist.find(item => item[0] === periodStartDateMillisecondsTemp);
            // корректировка для ytd - на первой итерации, если значение для 01 января найдено, равно продолжаем поиск
            if (button.type === 'ytd' && j === 0 && itemOffset !== undefined) {
              periodStartDateMillisecondsTemp -= millisecondsInDay;
              itemOffset = hist.find(item => item[0] === periodStartDateMillisecondsTemp);
            }
            if (itemOffset === undefined) {
              periodStartDateMillisecondsTemp -= millisecondsInDay;
            }
            j++;
          }
          if (itemOffset !== undefined) {
            offsetMin = itemOffset[0] - periodStartDateMilliseconds;
          } else {
           // console.log(periodStartDateMilliseconds, 'periodStartDateMilliseconds');
          //  console.log(hist[0][0], 'hist[0][0]');
            //console.log('!!! not offsetMin for ' + (button.count !== undefined ? button.count : '') + ' ' + button.type + ' - ' + offsetMin);
          }
          button['offsetMin'] = offsetMin;
          //console.log('offsetMin for ' + (button.count !== undefined ? button.count : '') + ' ' + button.type + ' - ' + offsetMin);
        }
      });
    }
  }

  init() {

    if (this._callbacks) {
      this._callbacks.afterSetExtremes = this._afterSetExtremes;
    }

    if (this._resId) {

     // getJSON(`ajax/get-mf.json?resurs_id=${this._resId}&type=${this._type}`).then((data) => {

      getJSON(`assets/components/dohod/connectorweb.php?type=${this._type}&tab=${this._tab}&action=${this._action}&resId=${this._resId}`).then((data) => {

        if(this._showMode === 'card') {
          // вычисление смещения offsetMin для кнопок с периодами, на случай,
          // если для даты начала периода данные отсутствуют
          this._setOffsetMins(data.items);
        }

        switch (this._tab) {
          case 'pai':
            this._options.series[0] = {
              name: 'Стоимость пая',
              // color:'#51a1ec',
              data: data.items,
            };
            break;
          case 'cha':
            this._options.series[0] = {
              name: 'Стоимость СЧА',
              // color:'#51a1ec',
              data: data.items,
            };
            break;
          case 'usdRate':
            this._options.series[0] = {
              name: 'Курс доллара',
              // color:'#51a1ec',
              data: data.items,
            };
            break;
        }
        if(this._showMode === 'card') {
          this._options.series[0].type = 'areaspline';
          this._options.series[0].fillColor = {
            linearGradient: {
              x1: 0,
              y1: 0,
              x2: 0,
              y2: 1
            },
            stops: [
              [0, Highcharts.getOptions().colors[0]],
              [1, Highcharts.color(Highcharts.getOptions().colors[0]).setOpacity(0).get('rgba')]
            ]
          };
        }

        Highcharts.setOptions({
          lang: {
            loading: 'Загрузка...',
            months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
            weekdays: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
            shortMonths: ['Янв', 'Фев', 'Март', 'Апр', 'Май', 'Июнь', 'Июль', 'Авг', 'Сент', 'Окт', 'Нояб', 'Дек'],
            exportButtonTitle: "Экспорт",
            printButtonTitle: "Печать",
            rangeSelectorFrom: 'Доходность за период c',
            rangeSelectorTo: "до",
            rangeSelectorZoom: "",
            downloadPNG: 'Скачать PNG',
            downloadJPEG: 'Скачать JPEG',
            downloadPDF: 'Скачать PDF',
            downloadSVG: 'Скачать SVG',
            printChart: 'Напечатать график'
          }
        });

        this._instance = Highcharts.stockChart(this._chart, this._options);

        const updatedOptions = Highcharts.merge({yAxis: {min: data.min}}, this._originalOptions);
        this._instance.update(updatedOptions);

        if (this._options.responsiveRules) {
          this._setResponsiveOptions();
        }
        // if (this._dates.start.element && this._dates.end.element) {
        //   this._initDateInputs();
        // }

      });

    }
    //this._table = new StockChartTable(this._element);
  }
}
